import { render, staticRenderFns } from "./SidebarView.vue?vue&type=template&id=7849af8b&"
import script from "./SidebarView.vue?vue&type=script&lang=js&"
export * from "./SidebarView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7849af8b')) {
      api.createRecord('7849af8b', component.options)
    } else {
      api.reload('7849af8b', component.options)
    }
    module.hot.accept("./SidebarView.vue?vue&type=template&id=7849af8b&", function () {
      api.rerender('7849af8b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/delivery/monitoring/SidebarView.vue"
export default component.exports